/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const project = feature.project;

    const blocks: CodeBlock[] = [];

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function getDatetimeUTC() {
    return Math.floor(Date.now() / 1000);
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function datetimeLocalToUTC(timestamp) {
    return timestamp - tzOffsets[APP_TIMEZONE] * 60;
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function datetimeUTCToDeviceTime(timestamp) {
    if (timestamp < 1e12) {
        timestamp = timestamp * 1000;
    }
    const date = new Date(Number(timestamp));
    const deviceTzOffset = tzOffsets[APP_TIMEZONE];
    date.setUTCMinutes(date.getUTCMinutes() + deviceTzOffset);
    return {
        date,
        timestamp: date.getTime() / 1000,
    };
}
    
function datetime_from_time(time) {
    const date = new Date(Number(time * 1000));
    return date.getTime();
}

function datetime_timestamp_seconds(timestamp) {
    const date = new Date(timestamp * 1000);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const result = hours * 3600 + minutes * 60 + seconds;
    return result;
}

function formatTimestamp(timestamp, format) {
    // const { date } = datetimeUTCToDeviceTime(timestamp);
    const date = new Date(timestamp * 1000);
    const pad = n => n.toString().padStart(2, '0');

    const tokens = {
        YYYY: date.getUTCFullYear(),
        MM: pad(date.getUTCMonth() + 1),
        DD: pad(date.getUTCDate()),
        HH: pad(date.getUTCHours()),
        hh: pad(date.getUTCHours() % 12 || 12),
        mm: pad(date.getUTCMinutes()),
        ss: pad(date.getUTCSeconds()),
        tt: date.getUTCHours() < 12 ? 'AM' : 'PM',
    };

    return format.replace(/YYYY|MM|DD|HH|hh|mm|ss|tt/g, match => tokens[match]);
}
`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function datetimeUTCToLocal(timestamp) {
    return timestamp + tzOffsets[APP_TIMEZONE] * 60;
}`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
const tzOffsets = [
    -12 * 60,         //  0: TD_TIMEZONE_GMT_MINUS_12_00
    -11 * 60,         //  1: TD_TIMEZONE_GMT_MINUS_11_00
    -10 * 60,         //  2: TD_TIMEZONE_GMT_MINUS_10_00
     -9 * 60,         //  3: TD_TIMEZONE_GMT_MINUS_09_00
     -8 * 60,         //  4: TD_TIMEZONE_GMT_MINUS_08_00
     -7 * 60,         //  5: TD_TIMEZONE_GMT_MINUS_07_00
     -6 * 60,         //  6: TD_TIMEZONE_GMT_MINUS_06_00
     -5 * 60,         //  7: TD_TIMEZONE_GMT_MINUS_05_00
     -4 * 60 - 30,    //  8: TD_TIMEZONE_GMT_MINUS_04_30
     -4 * 60,         //  9: TD_TIMEZONE_GMT_MINUS_04_00
     -3 * 60 - 30,    // 10: TD_TIMEZONE_GMT_MINUS_03_30
     -3 * 60,         // 11: TD_TIMEZONE_GMT_MINUS_03_00
     -2 * 60,         // 12: TD_TIMEZONE_GMT_MINUS_02_00
     -1 * 60,         // 13: TD_TIMEZONE_GMT_MINUS_01_00
      0,              // 14: TD_TIMEZONE_GMT
      1 * 60,         // 15: TD_TIMEZONE_GMT_PLUS_01_00
      2 * 60,         // 16: TD_TIMEZONE_GMT_PLUS_02_00
      3 * 60,         // 17: TD_TIMEZONE_GMT_PLUS_03_00
      3 * 60 + 30,    // 18: TD_TIMEZONE_GMT_PLUS_03_30
      4 * 60,         // 19: TD_TIMEZONE_GMT_PLUS_04_00
      4 * 60 + 30,    // 20: TD_TIMEZONE_GMT_PLUS_04_30
      5 * 60,         // 21: TD_TIMEZONE_GMT_PLUS_05_00
      5 * 60 + 30,    // 22: TD_TIMEZONE_GMT_PLUS_05_30
      5 * 60 + 45,    // 23: TD_TIMEZONE_GMT_PLUS_05_45
      6 * 60,         // 24: TD_TIMEZONE_GMT_PLUS_06_00
      6 * 60 + 30,    // 25: TD_TIMEZONE_GMT_PLUS_06_30
      7 * 60,         // 26: TD_TIMEZONE_GMT_PLUS_07_00
      8 * 60,         // 27: TD_TIMEZONE_GMT_PLUS_08_00
      9 * 60,         // 28: TD_TIMEZONE_GMT_PLUS_09_00
      9 * 60 + 30,    // 29: TD_TIMEZONE_GMT_PLUS_09_30
     10 * 60,         // 30: TD_TIMEZONE_GMT_PLUS_10_00
     11 * 60,         // 31: TD_TIMEZONE_GMT_PLUS_11_00
     12 * 60,         // 32: TD_TIMEZONE_GMT_PLUS_12_00
     13 * 60          // 33: TD_TIMEZONE_GMT_PLUS_13_00
];
        `,
    });

    return blocks;
};
